import Cookie from 'js-cookie'

import { isDevelopment } from './miscellaneous'

export const DOMAIN = isDevelopment
    ? window.location.hostname
    : '.openhouse.study'

Cookie.defaults.domain = DOMAIN
Cookie.defaults.expires = 30 // days
Cookie.defaults.sameSite = 'Lax'
Cookie.defaults.secure = !isDevelopment

export default Cookie
